module.exports = __webpack_public_path__ + "static/stories_illustrations_payment-278f63ab0d3076ba9559c57f8de834f6.svg";